// extracted by mini-css-extract-plugin
module.exports = {"page":"_11739","hd":"_2181","logo":"_14400","content":"_8707","name":"_19164","desc":"_2404","filter":"_1113","item":"_15786","active":"_7837","bd":"_16041"};